@if (isLoading) {
  <ix-layout-grid>
    <ix-row>
      <ix-col class="d-flex justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  </ix-layout-grid>
}

@if (!isLoading && !hasError) {
  <ix-layout-grid [columns]="12" class="w-100">
    <!-- Header -->
    <ix-row>
      <ix-col>
        <ix-content-header
          id="content-header"
          [hasBackButton]="false"
          [headerTitle]="'dpp.general.public_title' | translate: {name: headerTitle}"
        >
        </ix-content-header>
        <ix-tooltip for="#content-header">{{ headerTitle }}</ix-tooltip>
      </ix-col>
    </ix-row>

    <!-- Info Cards Section -->
    <ix-row class="info-cards-row">
      <ix-col
        size="6"
        sizeSm="12"
        class="thumbnail-col d-flex flex-column h-100 order-md-2"
      >
        <ix-card variant="outline" class="thumbnail-card w-100 h-100">
          <ix-card-content>
            <div
              class="thumbnail-wrapper"
              [style.background-image]="
                thumbnailUrl ? 'url(' + thumbnailUrl + ')' : 'none'
              "
            >
              @if (!thumbnailUrl) {
                <div class="thumbnail-placeholder">
                  <ix-icon name="image" size="32"></ix-icon>
                  <ix-typography format="caption">
                    {{
                      'dpp.passport_detail_view.no_thumbnail_available'
                        | translate
                    }}
                  </ix-typography>
                </div>
              }
            </div>
          </ix-card-content>
        </ix-card>
      </ix-col>
      <ix-col
        size="6"
        sizeSm="12"
        class="info-cards-left d-flex flex-column h-100 order-md-1"
      >
        <ix-card variant="outline" class="info-card mb-3 w-100">
          <ix-card-content>
            <ix-icon name="globe" size="32"></ix-icon>
            <ix-typography format="h4">{{
              'dpp.general.global_asset_id' | translate
            }}</ix-typography>
            <ix-typography format="body">
              {{ globalAssetId || '—' }}
            </ix-typography>
          </ix-card-content>
        </ix-card>
        <ix-card variant="outline" class="info-card w-100">
          <ix-card-content>
            <ix-icon name="document-bulk" size="32"></ix-icon>
            <ix-typography format="h4">{{
              'dpp.general.aas_id' | translate
            }}</ix-typography>
            <ix-typography format="body">
              {{ aasId || '—' }}
            </ix-typography>
          </ix-card-content>
        </ix-card>
      </ix-col>
    </ix-row>

    <!-- Submodels Section -->
    <ix-row>
      <ix-col>
        <ix-typography format="h4">
          {{ 'dpp.passport_detail_view.submodels_title' | translate }}
        </ix-typography>
      </ix-col>
    </ix-row>

    <!-- Submodels List -->
    @if (submodels.length > 0) {
      <ix-row>
        @for (submodel of submodels; track trackBySubmodel($index, submodel)) {
          <ix-col size="12" size-md="6" size-lg="3">
            <ix-card
              variant="outline"
              class="submodel-card h-100 w-100"
              (click)="onSubmodelSelected(submodel)"
              onkeypress=""
            >
              <ix-card-content>
                <div class="submodel-header">
                  <ix-icon
                    [name]="submodel.icon || defaultSubmodelIcon"
                    size="32"
                    class="submodel-icon"
                  ></ix-icon>
                  <div class="submodel-info">
                    <ix-typography format="label-lg" bold class="submodel-name">
                      {{ submodel.name || 'dpp.general.unknown' | translate }}
                    </ix-typography>
                    @if (submodel.version) {
                      <ix-pill variant="primary" class="version-pill">
                        {{
                          'dpp.passport_detail_view.version_prefix' | translate
                        }}{{ submodel.version }}
                      </ix-pill>
                    }
                  </div>
                </div>
                <ix-icon
                  name="chevron-right"
                  size="24"
                  class="chevron-icon"
                ></ix-icon>
              </ix-card-content>
            </ix-card>
          </ix-col>
        }
      </ix-row>
    }

    <!-- Empty State -->
    @if (submodels.length === 0) {
      <ix-row>
        <ix-col>
          <ix-empty-state
            icon="document"
            header="{{ 'dpp.passport_detail_view.no_submodels_available' | translate }}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    }
  </ix-layout-grid>

  <ix-row>
    <ix-col>
      <div class="d-flex flex-column align-items-center text-center gap-2 mt-3 mb-4 px-3">
        <ix-typography
          format="body-lg"
          id="publicDppLoginLabel"
        >{{ 'battery_pass.public.login_text' | translate }}</ix-typography>
        <ix-button
          variant="primary"
          [routerLink]="['/app/dpp/view-passport', dppId]"
          id="publicDppLoginButton"
        >{{ 'general.login' | translate }}</ix-button>
      </div>
    </ix-col>
  </ix-row>
}

@if (!isLoading && hasError) {
  <ix-layout-grid>
    <ix-row>
      <ix-col>
        <ix-empty-state
          icon="error"
          header="{{ 'dpp.passport_detail_view.not_found_message' | translate }}"
        ></ix-empty-state>
      </ix-col>
    </ix-row>
  </ix-layout-grid>
}
